const n = (s, e, Y) => {
  const l = e.indexOf(Y);
  return s.slice(l, l + Y.length);
}, I = (s, e = "YYYY-MM-DD HH.mm.ss", { epoch: Y = 2e3 } = {}) => {
  let l = Y;
  e.includes("YYYY") ? l = parseInt(n(s, e, "YYYY"), 10) : e.includes("YY") && (l = parseInt(n(s, e, "YY"), 10) + Y);
  let d = 0;
  e.includes("MM") && (d = parseInt(n(s, e, "MM"), 10) - 1);
  let i = 1;
  e.includes("DD") && (i = parseInt(n(s, e, "DD"), 10));
  let c = 0;
  e.includes("HH") && (c = parseInt(n(s, e, "HH"), 10));
  let t = 0;
  e.includes("mm") && (t = parseInt(n(s, e, "mm"), 10));
  let D = 0;
  return e.includes("ss") && (D = parseInt(n(s, e, "ss"), 10)), new Date(l, d, i, c, t, D);
}, u = {
  install(s) {
    s.filter("dateParse", I);
  }
};
export {
  I as dateParse,
  u as default
};
